import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { getErrorText } from 'src/app/service/ansokan-form-builder/validator-errors';
import { FormUtil } from 'src/app/util/form-util';

@Component({
    selector: 'app-area',
    templateUrl: './area.component.html',
    standalone: false
})
export class AreaComponent implements OnInit {

  @Input() public control: UntypedFormControl;
  @Input() public rows = 4;
  @Input() public maxLength: number;

  public get length(): number {
    return this.control && this.control.value ? this.control.value.length : 0;
  }

  public get required() {
    return FormUtil.hasValidator(this.control);
  }

  public get error(): string {
    return getErrorText(this.control);
  }

  constructor() { }

  public ngOnInit() {
  }
}
